import { useEffect, useState } from 'react';

const Avatar = ({
  url,
  name,
  imageClassName,
  initialClassName,
  imageContainerClassName,
}: {
  url: string;
  name: string;
  imageClassName?: string;
  initialClassName?: string;
  imageContainerClassName?: string;
}) => {
  const [isProfileImage, setIsProfileImage] = useState(false);
  useEffect(() => {
    if (url) setIsProfileImage(true);
  }, [url]);

  return (
    <div>
      {isProfileImage ? (
        <div
          className={`max-w-[40px] max-h-[40px] rounded-full overflow-hidden flex justify-center items-center ${imageContainerClassName}`}
        >
          <img
            src={url}
            alt={name}
            className={` object-cover ${
              imageClassName ? imageClassName : 'min-w-[40px] min-h-[40px]'
            }`}
            onError={() => setIsProfileImage(false)}
          />
        </div>
      ) : (
        <div
          className={` w-10 h-10 bg-[#5557C9] bg-opacity-20 rounded-full ring-1 ring-transparent flex justify-center items-center ${initialClassName}`}
        >
          <span className="flex justify-center capitalize items-center h-full font-SFProDisplay font-bold text-sm text-[#5557C9]">
            {name.substring(0, 1)}
          </span>
        </div>
      )}
    </div>
  );
};
export default Avatar;
